module.exports = __webpack_public_path__ + "static/hero-2-img-1-08ba418ace5db40872744cd6a45b82a7.png";